import { render, staticRenderFns } from "./SmartTableWizard.vue?vue&type=template&id=6bade379&scoped=true"
import script from "./SmartTableWizard.vue?vue&type=script&lang=js"
export * from "./SmartTableWizard.vue?vue&type=script&lang=js"
import style0 from "./SmartTableWizard.vue?vue&type=style&index=0&id=6bade379&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bade379",
  null
  
)

export default component.exports